import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { withSentryReactRouterV6Routing } from '@sentry/react';

import { PageSpinner } from '@atoms';
import { AcceptTermsModal, TopLevelErrorBoundary } from '@organisms';
import { AuthCallback, FourOhFour, FourOhOne, FourOhThree } from '@pages';

import ChunkLoadErrorBoundary from '../components/atoms/ChunkLoadErrorBoundary/ChunkLoadErrorBoundary';
import LoginV2 from '../components/pages/LoginV2';

import { isServiceConsole } from '../helpers';

import SnackbarProvider from '../providers/SnackbarProvider/SnackbarProvider';

const Admin = lazy(() => import('./admin'));
const Console = lazy(() => import('./console/index'));

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

function MainRoute() {
  return (
    <BrowserRouter>
      <TopLevelErrorBoundary>
        <ChunkLoadErrorBoundary>
          <SnackbarProvider>
            <AcceptTermsModal />
            <Suspense fallback={<PageSpinner />}>
              <SentryRoutes>
                <Route path="/login" element={<LoginV2 />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/404" element={<FourOhFour />} />
                <Route path="/403" element={<FourOhThree />} />
                <Route path="/401" element={<FourOhOne />} />
                {isServiceConsole && <Route path="/*" element={<Admin />} />}
                {!isServiceConsole && <Route path="/*" element={<Console />} />}
                <Route path="*" element={<Navigate replace to="/404" />} />
              </SentryRoutes>
            </Suspense>
          </SnackbarProvider>
        </ChunkLoadErrorBoundary>
      </TopLevelErrorBoundary>
    </BrowserRouter>
  );
}

export default MainRoute;
